/*
 * @Author: hanjiyun 
 * @Email: hanjiyun@douban.com
 * @Date: 2023-11-10 16:53:23 
 * @Last Modified by: hanjiyun
 * @Last Modified time: 2025-02-28 15:00:49
 * @Description: 
 */

import { IS_DEV, IS_PREVIEW } from '../const'
import { amonsulEvent } from '@douban/amonsul/lib/web'

const Log = (event: string, label={}) => {
  if (!IS_DEV && !IS_PREVIEW) {
    amonsulEvent(event, {
      ...label,
      page_name: 'douban20th-anniversary'
    })
  }
}

export default Log
